// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tab":"tab_ryaTG"};